module.exports = __webpack_public_path__ + "static/favicon-cfb4851edafe2aa06eb8c8725a4b6eb9.ico";